module.exports = __webpack_public_path__ + "static/img/ic_heart_on@2x.4aa1b5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_heart_on@2x.png
// module id = FaI0
// module chunks = 1